import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/individual-profile/components/IndividualProfileContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Topbar.tsx");
